import { motion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'
import SectionTitle from './SectionTitle'

const Platforms = () => {

  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  })
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"])
  
  return (
    <section id="platforms" className="bg-ds-off-white py-16 sm:py-20 lg:py-28">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-12">
        <SectionTitle title="PLATFORMS" />

        <div className="grid lg:grid-cols-[35%_1fr] gap-8 sm:gap-10 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
            className="relative order-1 lg:order-1"
          >
            <div className="relative overflow-hidden rounded-tr-3xl rounded-br-3xl shadow-2xl -ml-4 sm:-ml-6 lg:-ml-12">
              <motion.div style={{ y }} className="image-overlay">
                <img
                  src="/platforms_img.png"
                  alt="Development workspace with multiple devices"
                  className="w-full h-56 sm:h-72 lg:h-[450px] object-cover scale-110"
                />
              </motion.div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-4 sm:space-y-6 order-2 lg:order-2"
          >
            <p className="font-body text-base lg:text-lg text-ds-navy leading-relaxed">
              Daily Stride LLC develops applications for both iOS and web-based platforms, ensuring that 
              each product is designed, tested, and maintained in accordance with industry standards and 
              platform guidelines.
            </p>
            
            <p className="font-body text-base lg:text-lg text-ds-navy leading-relaxed">
              Our commitment to compliance and quality means that every app we release is built to deliver 
              a seamless user experience, while meeting the technical and policy requirements of the 
              platforms we support.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Platforms
